import { render, staticRenderFns } from "./expandMenu.vue?vue&type=template&id=6a683a66&scoped=true"
import script from "./expandMenu.vue?vue&type=script&lang=js"
export * from "./expandMenu.vue?vue&type=script&lang=js"
import style0 from "./expandMenu.vue?vue&type=style&index=0&id=6a683a66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a683a66",
  null
  
)

export default component.exports